/**
 * ConstructionPhase - Represents a construction phase or stage in a project.
 * Used to organize and sequence construction activities by year, stage, class, and group.
 */
export class ConstructionPhase {
  /** Year of the construction phase */
  YR: number;

  /** Stage number */
  Stage: number;

  /** Classification number */
  Class: number;

  /** Group identifier */
  Group: string;

  /** Sequence number for ordering */
  Sequence: number;

  /** Name of the activity */
  ActivityName: string;

  /**
   * Creates a new ConstructionPhase instance
   * @param data - Object containing construction phase properties
   */
  constructor(data: {
    YR: number;
    Stage: number;
    Class: number;
    Group: string;
    Sequence: number;
    ActivityName: string;
  }) {
    this.YR = data.YR;
    this.Stage = data.Stage;
    this.Class = data.Class;
    this.Group = data.Group;
    this.Sequence = data.Sequence;
    this.ActivityName = data.ActivityName;
  }

  /**
   * Creates a ConstructionPhase from a plain object (useful for deserialization)
   * @param obj - Plain object with construction phase data
   * @returns New ConstructionPhase instance
   */
  static fromObject(obj: Partial<ConstructionPhase>): ConstructionPhase {
    return new ConstructionPhase({
      YR: obj.YR ?? 0,
      Stage: obj.Stage ?? 0,
      Class: obj.Class ?? 0,
      Group: obj.Group ?? "",
      Sequence: obj.Sequence ?? 0,
      ActivityName: obj.ActivityName ?? "",
    });
  }

  /**
   * Converts the ConstructionPhase to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      YR: this.YR,
      Stage: this.Stage,
      Class: this.Class,
      Group: this.Group,
      Sequence: this.Sequence,
      ActivityName: this.ActivityName,
    };
  }
}


